// extracted by mini-css-extract-plugin
module.exports = {"container":"container___vhtCK","titleContainer":"title-container___2fg6n","title":"title___twgON","content":"content___ga9LV"};